<span class="interactive" [class.small]="small"></span>
<svg [class.small]="small" (selectstart)="$event.preventDefault()" (mousedown)="$event.preventDefault()" [icon]="icon" />
